module.exports = __webpack_public_path__ + "img/ic_drawer_1_checked.c8e143af.svg";